import { Radio } from 'lucide-react';

export default function LiveVisitors() {
  // No live visitor endpoint available yet — hide this widget until real-time data is supported
  // TODO: Replace with WebSocket/SSE endpoint when available (e.g. GET /api/v1/live-visitors)
  return null;
}
